import { useCallback, useContext, useEffect, useState } from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

import { AuthContext } from 'context/AuthContext';
import { getFaqContent } from 'services/content.service';

type Props = {
  _id: string;
  title: string;
};

export default function FaqItem({ _id, title }: Props) {
  const [contentData, setContentData] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [opened, setOpened] = useState<boolean>(false);
  const { user } = useContext(AuthContext);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFaqContent(_id, user?.extra.rede);
      setContentData(data);
      setLoading(false);
    } catch (error) {}
  }, [_id, user?.extra.rede]);

  useEffect(() => {
    if (opened && !loading && typeof contentData !== 'string') {
      loadData();
    }
  }, [contentData, loadData, loading, opened]);

  return (
    <div className={`rb-accordion ${opened ? 'is-open' : ''}`}>
      <button type="button" className="rb-accordion__header" onClick={() => setOpened(prev => !prev)} aria-expanded={opened}>
        <h3 className="rb-accordion__title">{title}</h3>
        {opened ? <BiChevronUp size={26} /> : <BiChevronDown size={26} />}
      </button>

      {opened &&
        (loading ? (
          <div className="rb-accordion__body">
            <div className="rb-skeleton" style={{ height: 80 }} />
          </div>
        ) : (
          <div
            className="rb-accordion__body rb-prose"
            dangerouslySetInnerHTML={{ __html: contentData || '' }}
            tabIndex={0}
            aria-label={contentData}
          />
        ))}
    </div>
  );
}
